import { Navigate, useParams } from 'react-router-dom';
import { DashboardFormWrapper } from '../dashboard';
import { UserVisitsPage } from './UserVisitsComponents';
import { UserVisitsViewHeader, UserVisitsViewForm } from './UserVisitsViewComponents';
import { useUserVisitQuery } from '../../hooks';
import { RoleGuard } from '../../routes';

export const UserVisitsView = () => {
  const params: any = useParams();
  const { data, isFetching } = useUserVisitQuery(params.id);

  if (isFetching) return <></>;
  if (!data || !data.totalCount) return <Navigate to={'/dashboard/user-visits'} replace />;

  return (
    <RoleGuard roles={['SUPER_ADMIN']}>
      <UserVisitsPage>
        <UserVisitsViewHeader {...data} />
        <DashboardFormWrapper flow={'row'}>
          <UserVisitsViewForm {...data} />
        </DashboardFormWrapper>
      </UserVisitsPage>
    </RoleGuard>
  );
};
